// USDR converter: swaps USDT to/from USDR at a fixed 1:1 rate.
// sellStable(ilkId, user, stableAmt) pulls USDT from msg.sender and mints the
// 18-decimal USDR equivalent straight to `user`. buyStable is the reverse:
// it burns USDR from msg.sender (approval needed) and sends USDT to `user`.
// In both directions stableAmt is in USDT's own units (6 decimals).
import { USDR_CONVERTER_ADDRESS, CONVERTER_USDT_ID } from "./Enviroment";

export { USDR_CONVERTER_ADDRESS, CONVERTER_USDT_ID };

// No converter in this environment -> USDT deposits and USDT payouts are off
export const IS_USDT_CONVERSION_ENABLED = !!USDR_CONVERTER_ADDRESS && !!CONVERTER_USDT_ID;

export const USDR_CONVERTER_ABI = [
    {
        inputs: [
            { internalType: "bytes32", name: "ilkId", type: "bytes32" },
            { internalType: "address", name: "user", type: "address" },
            { internalType: "uint256", name: "stableAmt", type: "uint256" },
        ],
        name: "sellStable",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            { internalType: "bytes32", name: "ilkId", type: "bytes32" },
            { internalType: "address", name: "user", type: "address" },
            { internalType: "uint256", name: "stableAmt", type: "uint256" },
        ],
        name: "buyStable",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    // Listed so viem decodes the revert instead of returning raw hex
    { inputs: [], name: "CeilingExceeded", type: "error" },
    { inputs: [], name: "InsufficientFreeSlack", type: "error" },
];

export const CONVERTER_CAPACITY_MESSAGE = "The converter is at capacity right now. Try a smaller amount or try again later.";
export const CONVERTER_RESERVE_HEADING = "Withdrawals are unavailable right now";
export const CONVERTER_RESERVE_MESSAGE = "USDT withdrawals are temporarily unavailable. Please try again later.";

// viem nests the revert several `cause` levels deep and puts the selector in
// different fields, so flatten the whole chain into one string
const errorText = (error) => {
    const seen = new Set();
    let text = "";
    for (let e = error; e && !seen.has(e); e = e.cause) {
        seen.add(e);
        text += `${e.name ?? ""} ${e.message ?? ""} ${e.shortMessage ?? ""} ${e.signature ?? ""} ${e.data ?? ""} `;
    }
    return text;
};

// Amount is over the converter's current capacity: a smaller amount can work
export const isConverterCapacityError = (error) => {
    const text = errorText(error);
    return (
        text.includes("CeilingExceeded") ||
        text.includes("InsufficientFreeSlack") ||
        text.includes("0x20caa94a") ||
        text.includes("0x04beb7ff")
    );
};

// The converter holds too little USDT for the payout: a smaller amount won't help
export const isConverterReserveError = (error) => {
    const text = errorText(error);
    return text.includes("ERC20InsufficientBalance") || text.includes("0xe450d38c");
};
